@if (showLoader) {
<por-app-loader></por-app-loader>
} @if (customer$ | async | count) {
<ng-container>
    <por-header [config]="config" [customer]="customer$ | async" (logout)="logoutUser()" (manageUsers)="viewContacts()"></por-header>
</ng-container>
@if (appFacadeService.isAccountFeaturesLoaded() | async) { @switch (appFacadeService.getActiveTab() | async) { @case ('Tracking') {
<por-tracking [config]="config" [hidden]="appFacadeService.isManageUserDialogDisplayed() | async"></por-tracking>
} @default { @if (appFacadeService.featureToggleService.isAvailable('Account.ViewContracts')) {
<por-contracts [hidden]="appFacadeService.isManageUserDialogDisplayed() | async" [customer]="customer$ | async" [config]="config"></por-contracts>
} @else {
<div class="por no-view-contracts-message">
    <p>{{ 'NoViewContractsPermissionMessage' | translate }}</p>
</div>
} } } } }
